<script>
  import { setContext, getContext } from "svelte";
  import { ENTRIES } from "./app_config.js";
  import t from "$lib/i18n.svelte.js";
  import { fetch_json, entry_url } from "$lib/util.js";
  import { invalidateAll, goto } from '$app/navigation';
  import MainPageContent from "$lib/MainPageContent.svelte";
  import Dialog from "$lib/Dialog.svelte";
  let { entry_id, onclose } = $props();
  
  // This is "sort of" considered derived state initially (see effect)
  // let entry = $state(new ENTRIES[raw_entry.type].model(raw_entry));
  let entry = $state(undefined);
  let site_settings = getContext('site_settings');
  // The parent entry_api
  // let entry_api = getContext('entry_api');
  let first_block_background_color = $derived(entry?.body?.blocks?.[0]?.background_color);
  let is_editing = $state(true);
  let active_container = $state(undefined);
  // Call this (from different) places to reset 
  // E.g. when <PlainText> calls this when not provided with an explicit focus property.
  function clear_selection() {
    active_container?.clear_selection();
    active_container = undefined;
  }

  function start_editing() {
    is_editing = true;
    clear_selection();
  }

  function cancel_editing() {
    onclose(); // go back to the previous context
  }

  async function save() {
    const new_or_updated_entry = entry.to_json();
    try {
      if (new_or_updated_entry.entry_id) {
        await fetch_json('POST', '/api/update-entry', new_or_updated_entry);
        onclose();
      }
    } catch (err) {
      console.error(err);
      alert('There was an error. You can try again, but before that, please just copy and paste your article into a safe place.');
    }
    is_editing = false;
    clear_selection();
  }

  setContext("entry_api", {
    is_contextual_editing: true,
    get is_disabled() {
      return false;
    },
    get page_title() {
      return entry.preview.title;
    },
    get page_description() {
      return entry.preview.description;
    },
    get entry() {
      return entry;
    },
    get active_container() {
      return active_container;
    },
    set active_container(_active_container) {
      // we clear the selection of the other container, when switching
      active_container?.clear_selection();
      active_container = _active_container;
    },
    get is_editing() {
      return is_editing;
    },
    set is_editing(_is_editing) {
      is_editing = _is_editing;
    },
    clear_selection,
    cancel_editing,
    start_editing,
    save,
  });
  $effect(async () => {
    // TODO: load entry from server, but for now we just use the same entry
    const raw_entry = await fetch_json('POST', '/api/entry', { entry_id});
    entry = new ENTRIES[raw_entry.type].model(raw_entry);
  });
</script>
  <!-- {@html `<style>:root{--first-block-background-color: ${first_block_background_color}}</style>`} -->

<div class="in-place-editor">
  {#if entry}
    <MainPageContent
      id={entry.type + '-' + entry.entry_id}
      {is_editing}
    >
      {@const EntryTypeComponent = ENTRIES[entry.type].component}
      <EntryTypeComponent {entry} {is_editing} /> 
    </MainPageContent>
  {:else}
    loading...
  {/if}
</div>